export const MAIN_SITE = (process.env.REACT_APP_WEB_URL || "https://deliva-for-web.vercel.app").replace(/\/+$/, "");

export const PRICE_PLAN_URL = `${MAIN_SITE}/advertise`;
